import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UntypedFormBuilder, UntypedFormGroup, NgForm, Validators, FormControl } from '@angular/forms';
import { HttpClient, HttpParams} from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { environment } from 'src/environments/environment';
import { ProjectService } from 'src/app/_services/project.service';
@Component({
  selector: 'app-add-module',
  templateUrl: './add-module.component.html',
  styleUrls: ['./add-module.component.scss']
})
export class AddModuleComponent implements OnInit {

  addTestModuleForm:UntypedFormGroup;
  projectName: any;
  submitted= false;
  url: string;
  title: any;
  projectId: any;
  parentTestDataId: any;
  constructor(@Inject(MAT_DIALOG_DATA) public data,
  private formBuilder: UntypedFormBuilder,
  private http: HttpClient,
  private toastrService: ToastrService,
  private projectService : ProjectService,
  public dialogRef: MatDialogRef< AddModuleComponent>) { 
    this.url=environment.baseUrl;
  
    this.title= data.message.name; 
     this.projectId= data.message.items[0].projectId;
     this.parentTestDataId= data.message.items[0].parentTestDataId;
    
  }
  ngOnInit() {
    this.loadForm();
  }

  get f() { return this.addTestModuleForm.controls; }

  loadForm(){
    this.addTestModuleForm = this.formBuilder.group({
      name:['',[
        Validators.required,
        Validators.pattern(/^(\s+\S+\s*)*(?!\s).*$/)
    ]],
      comment:['']
    })
  }

  onModuleAdd(){
    this.submitted = true;
    if(this. addTestModuleForm.invalid){
      return;
    }
    var objFormval = this.addTestModuleForm.value;
    if (! /^[^:|*?<>/\\"]+$/.test(objFormval.name)) {
      this.toastrService.clear();
      this.toastrService.warning('Suite Name is not Valid, Name cannot contain /[<>:"\/\\|?*');
      return;
    }

    this.submitDialog();

    const ValueForAdd={
      dependent: "false", 
      title: objFormval.name, 
      comment: objFormval.comment,
       projectId: this.projectId,
       parentTestDataId: this.parentTestDataId
    }
    
    //console.log(objFormval); 
    //console.log("");
    //console.log(ValueForAdd);//http://beatblipdemo.agreeya.net /HuLoopRest/huloop/test/addTestFile
    
    this.http.post(this.url + '/HuLoopRest/huloop/test/addTestFile'   ,ValueForAdd). subscribe((data) => {
      if(data) {
        this.toastrService.clear();
        this.toastrService.success( 'Process added successfully'); 
          //console.log("projectData", data); 
          }  
     });
    
    
    
  }
  closeDialog() {
    this.dialogRef.close(false);
  }

  submitDialog() {
    this.dialogRef.close(true);
  }

}
